import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import {
  PayoutReqResLogs,
  StatusCheck,
} from "../services/payoutReqResLogsService";

const initialState = {
  payoutReqResLogsState: [],
  isLoading: true,
  statusData: {},
  statusLoading: true,
};
export const getPayoutReqResLogs = createAsyncThunk(
  "/payoutRequestResponseLogs",
  async (payload) => {
    return await PayoutReqResLogs(payload);
  }
);
export const getStatusCheck = createAsyncThunk(
  "/check/status",
  async (payload) => {
    return await StatusCheck(payload);
  }
);

const payoutReqResLogsSlice = createSlice({
  name: "payoutReqResLogsSlice",
  initialState,
  reducers: {
    clearPayoutReqResLogs: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getPayoutReqResLogs.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(getPayoutReqResLogs.fulfilled, (state, action) => {
      state.isLoading = false;
      state.payoutReqResLogsState = action.payload;
    });
    builder.addCase(getPayoutReqResLogs.rejected, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(getStatusCheck.pending, (state, action) => {
      state.statusLoading = true;
    });
    builder.addCase(getStatusCheck.fulfilled, (state, action) => {
      state.statusLoading = false;
      state.statusData = action.payload;
    });
    builder.addCase(getStatusCheck.rejected, (state, action) => {
      state.statusLoading = false;
    });
  },
});
export default payoutReqResLogsSlice.reducer;
export const { clearPayoutReqResLogs } = payoutReqResLogsSlice.actions;

export const selectPayoutReqResLogs = (state) => {
  return state.payoutReqResLogs.payoutReqResLogsState;
};

export const usePayoutReqResLogs = () => {
  const payoutReqResLogsState = useSelector(selectPayoutReqResLogs);
  return useMemo(() => ({ payoutReqResLogsState }), [payoutReqResLogsState]);
};

export const selectStatusCheck = (state) => {
  return state.payoutReqResLogs.statusData;
};

export const useStatusCheck = () => {
  const statusDataState = useSelector(selectStatusCheck);
  return useMemo(() => ({ statusDataState }), [statusDataState]);
};
